export default __webpack_public_path__ + "static/media/AirportOperations.8f39ec3e.png";